import {
  Component,
  ViewChild,
  Renderer2,
  ElementRef,
  HostListener,
  Output,
  Input,
  EventEmitter,
  OnInit,
} from "@angular/core";
import { animate, AnimationBuilder, style } from "@angular/animations";

import { fadeInOut } from "src/app/common/animations/animations";

const BOARD_CONTAINER = "essencial-game-board";

@Component({
  selector: "app-game",
  templateUrl: "./game.component.html",
  styleUrls: ["./game.component.scss"],
  animations: [fadeInOut],
})
export class GameComponent implements OnInit {
  @Output() ended = new EventEmitter<boolean>();
  @Output() makePoints = new EventEmitter<number>();
  @Output() onCorrectMoves = new EventEmitter<number>();
  @Output() onIncorrectMoves = new EventEmitter<number>();
  @Output() onMoves = new EventEmitter<number>();
  @Output() timeLeft = new EventEmitter<any>();
  @Output() gameLoaded = new EventEmitter<boolean>();
  @Output() onGameStarted = new EventEmitter<boolean>();

  @Input() points: number = 0;
  @Input() loading: boolean = false;
  @Input() timer: number = 0;
  @Input() maxMoves: number = 0;
  @Input() tiles: string[] = [
    "item_1.jpg",
    "item_2.jpg",
    "item_3.jpg",
    "item_4.jpg",
  ];

  //GAME VARIABLES
  // sound = new Howl({src: ['/assets/sounds/combo.mp3'], html5: true});

  SWIPE_ACTION = {
    LEFT: "swipeleft",
    RIGHT: "swiperight",
    UP: "swipeup",
    DOWN: "swipedown",
  };

  itemSize: number = 20;
  itemClass: string = "item";
  itemIDPrefix: string = "item";
  itemState: string = "pick";
  itemStarted?: number;

  selectedItemRef: any;

  numRows: number = 8;
  numCols: number = 5;
  selectedRow: number = -1;
  selectedCol: number = -1;

  items: any[] = [];
  time: any = { seconds: "00", minutes: "00" };
  prefix?: string;
  interval?: number;

  correctMoves: number = 0;
  movements: number = 0;
  movingItems: number = 0;

  size: number = 10;
  height: number = 0;
  width: number = 0;
  gap: number = 0;
  posX: number = 0;
  posY: number = 0;
  initialLoad: boolean = false;

  started: boolean = false;
  counter: number = 0;
  blocked: boolean = false;
  isGameStarted: boolean = false;
  isTimeController: boolean = false;

  itemNumber: number = this.tiles.length;

  @ViewChild("strikeImage", { read: ElementRef })
  strikeImage?: ElementRef;
  @ViewChild("gameField", { read: ElementRef })
  gameField?: ElementRef;
  @ViewChild("instructions")
  public instructions?: any;

  @HostListener("window:resize", ["$event"])
  resize(_event: any) {
    this.init();
  }

  constructor(
    private renderer: Renderer2,
    private _builder: AnimationBuilder
  ) {}

  ngOnInit(): void {
    this.isTimeController = this.timer > 0;
  }

  handleInit() {
    this.start();
    this.gameLoaded.emit(true);
  }

  start() {
    if (!this.started) {
      this.initiateFieldMatrix();
      this.generateInitialItems();
      this.resize(null);

      this.started = true;

      this.interval = window.setInterval(() => {
        if (!this.isGameStarted) {
          return;
        }

        this.timer--;

        const minutes = Math.floor(this.timer / 60) % 60;
        const seconds = Math.floor(this.timer % 60);

        this.time.minutes = minutes.toString().padStart(2, "0");
        this.time.seconds = seconds.toString().padStart(2, "0");

        if (this.isTimeController) {
          if (this.timer <= 0) {
            this.timer = 0;
            this.finished();
          }

          this.timeLeft.emit(this.time);
        } else {
          this.movementsController();
        }
      }, 1000);
    }
  }

  movementsController() {
    if (this.movements >= this.maxMoves) {
      this.blocked = true;

      if (this.itemState === "pick") {
        this.blocked = false;

        setTimeout(() => {
          this.finished();
        }, 800);
      }
    }
  }

  finished() {
    if (!this.blocked) {
      this.blocked = true;
      clearInterval(this.interval);
      this.ended.emit(true);
    }
  }

  startGame() {
    if (!this.started) {
      this.start();
    }

    this.isGameStarted = true;
    this.onGameStarted.emit(true);
  }

  init() {
    const containreD = document.getElementById(BOARD_CONTAINER);

    let containerWidth = containreD ? containreD.offsetWidth : 290;

    if (containerWidth > 700) {
      containerWidth = 690;
    }

    this.itemSize = Math.floor(containerWidth / this.numCols) + this.gap;

    const itemsElements = Array.from(
      document.getElementsByClassName("item") as HTMLCollectionOf<HTMLElement>
    );

    for (let i = 0; i < itemsElements.length; i++) {
      let item = itemsElements[i];
      let p =
        item && item.getAttribute("id")
          ? item.getAttribute("id").split("_")
          : undefined;

      if (p) {
        item.style.width = this.itemSize + "px";
        item.style.left = (this.itemSize + this.gap) * parseInt(p[2]) + "px";
        item.style.top = (this.itemSize + this.gap) * parseInt(p[1]) + "px";
      }
    }

    this.width = this.itemSize * this.numCols;
    this.height = this.itemSize * this.numRows;
  }

  getId(row: number, col: number): string {
    this.prefix = this.itemIDPrefix + "_" + row + "_" + col;
    return this.itemIDPrefix + "_" + row + "_" + col;
  }

  getItem(row: number, col: number): HTMLElement {
    return document.getElementById(this.getId(row, col)) as HTMLElement;
  }

  initiateFieldMatrix() {
    for (let i = 0; i < this.numRows; i++) {
      this.items[i] = [];
      for (let j = 0; j < this.numCols; j++) {
        this.items[i][j] = -1;
      }
    }
  }

  generateInitialItems() {
    for (let i = 0; i < this.numRows; i++) {
      for (let j = 0; j < this.numCols; j++) {
        do {
          this.items[i][j] = Math.floor(Math.random() * this.itemNumber) + 1;
        } while (this.isStreak(i, j));

        const item = this.renderer.createElement("div");

        this.renderer.appendChild(
          this.gameField ? this.gameField.nativeElement : undefined,
          item
        );

        this.renderer.addClass(item, this.itemClass);
        this.renderer.setAttribute(item, "id", this.getId(i, j));
        this.renderer.setAttribute(item, "data-type", String(this.items[i][j]));
        this.renderer.addClass(item, this.tiles[this.items[i][j] - 1]);
        this.renderer.setStyle(item, "background-size", "100%");
        this.renderer.setStyle(item, "background-repeat", "no-repeat");
        this.renderer.setStyle(item, "background-position", "center");
      }
    }
    //All producs generated without streak
    this.initialLoad = true;
  }

  isStreak(row: number, col: number) {
    const streak =
      this.isVerticalStreak(row, col) || this.isHorizontalStreak(row, col);

    return streak;
  }

  isVerticalStreak(row: number, col: number) {
    const itemValue = this.items[row][col];
    let streak = 0;
    let tmp = row;

    while (
      tmp > 0 &&
      this.items[tmp - 1][col] &&
      this.items[tmp - 1][col] === itemValue
    ) {
      streak++;
      tmp--;
    }
    tmp = row;

    while (tmp < this.numRows - 1 && this.items[tmp + 1][col] === itemValue) {
      streak++;
      tmp++;
    }

    return streak > 1;
  }

  isHorizontalStreak(row: number, col: number) {
    const itemValue = this.items[row][col];
    let streak = 0;
    let tmp = col;

    while (tmp > 0 && this.items[row][tmp - 1] === itemValue) {
      streak++;

      tmp--;
    }
    tmp = col;

    while (tmp < this.numCols && this.items[row][tmp + 1] === itemValue) {
      streak++;
      tmp++;
    }

    return streak > 1;
  }

  onTap(event: any) {
    if (this.blocked || !this.isGameStarted) return;

    const selectedItem = event.target;

    if (selectedItem && selectedItem.classList.contains("item-selected")) {
      selectedItem.classList.remove("item-selected");

      this.selectedRow = -1;
      this.selectedCol = -1;
      this.itemStarted = -1;

      if (this.selectedItemRef) {
        this.selectedItemRef.classList.remove("item-selected");
        this.selectedItemRef = null;
      }

      return;
    }

    if (
      this.selectedItemRef &&
      this.selectedItemRef.classList.contains("item-selected")
    ) {
      this.selectedItemRef.classList.remove("item-selected");
    }

    this.selectedItemRef = selectedItem;

    if (selectedItem.classList.contains(this.itemClass)) {
      if (this.itemState === "pick") {
        const row = +selectedItem.getAttribute("id").split("_")[1];
        const col = +selectedItem.getAttribute("id").split("_")[2];

        this.selectedItemRef.classList.add("item-selected");
        this.itemStarted = -1;

        // ! FIrst item selected
        if (this.selectedRow === -1) {
          this.selectedRow = row;
          this.selectedCol = col;
          // ! Second item tapped
        } else {
          if (
            (Math.abs(this.selectedRow - row) === 1 &&
              this.selectedCol === col) ||
            (Math.abs(this.selectedCol - col) === 1 && this.selectedRow === row)
          ) {
            if (this.selectedItemRef.classList.contains("item-selected"))
              this.selectedItemRef.classList.remove("item-selected");

            this.itemState = "switch";
            this.posX = col;
            this.posY = row;
            this.productSwitch();
          } else {
            this.selectedRow = row;
            this.selectedCol = col;
          }

          this.handleMovements();
        }
      }
    }
  }

  handleMovements() {
    this.movements++;
    this.onMoves.emit(this.movements);
  }

  // ! Change and do animation independent if it's streak or not
  productSwitch() {
    const yOffset = this.selectedRow - this.posY;
    const xOffset = this.selectedCol - this.posX;
    const item1 = this.getItem(this.selectedRow, this.selectedCol);
    const item2 = this.getItem(this.posY, this.posX);
    this.renderer.setAttribute(item1, "dir", "-1");
    this.renderer.setAttribute(item2, "dir", "1");
    [item1, item2].forEach((item) => {
      this.movingItems++;
      this.animateProduct(item, xOffset, yOffset);
    });

    this.renderer.setAttribute(item1, "id", "temp");
    this.renderer.setAttribute(
      item2,
      "id",
      this.getId(this.selectedRow, this.selectedCol)
    );
    this.renderer.setAttribute(item1, "id", this.getId(this.posY, this.posX));

    const temp = this.items[this.selectedRow][this.selectedCol];
    this.items[this.selectedRow][this.selectedCol] =
      this.items[this.posY][this.posX];
    this.items[this.posY][this.posX] = temp;
  }

  animateProduct(item: HTMLElement, xOffset: number, yOffset: number) {
    if (!item) {
      return;
    }

    const dir = parseInt(
      item.getAttribute("dir") !== null &&
        item.getAttribute("dir") !== undefined
        ? item.getAttribute("dir")
        : "1"
    );
    const left = item.style.left.replace("px", "");
    const top = item.style.top.replace("px", "");
    const maxLeft = +left + xOffset * (this.itemSize + this.gap) * +dir;
    const maxTop = +top + yOffset * (this.itemSize + this.gap) * +dir;
    const myAnimation = this._builder.build([
      style({ left: +left + "px", top: +top + "px" }),
      animate(250, style({ left: +maxLeft + "px", top: +maxTop + "px" })),
    ]);
    const player = myAnimation.create(item);

    player.onDone(() => {
      this.renderer.setStyle(item, "left", maxLeft + "px");
      this.renderer.setStyle(item, "top", maxTop + "px");
      this.checkMoving();
    });

    player.play();
  }

  // ! Verify if its strike or not, if yes remove items, if not revert items
  checkMoving() {
    this.movingItems--;

    if (this.movingItems === 0) {
      switch (this.itemState) {
        case "switch":
        case "revert":
          //Is not a strike
          if (
            !this.isStreak(this.selectedRow, this.selectedCol) &&
            !this.isStreak(this.posY, this.posX)
          ) {
            if (this.itemState !== "revert") {
              this.itemState = "revert";
              this.productSwitch();
              top: 0;
              this.itemState = "pick";
              this.selectedRow = -1;
            }
            //It's strike
          } else {
            if (this.selectedItemRef.classList.contains("item-selected"))
              this.selectedItemRef.classList.remove("item-selected");

            this.itemState = "remove";

            if (this.isStreak(this.selectedRow, this.selectedCol)) {
              this.removeItems(this.selectedRow, this.selectedCol);
              this.changeStrikeImage(this.selectedRow, this.selectedCol, true);
            }

            if (this.isStreak(this.posY, this.posX)) {
              this.removeItems(this.posY, this.posX);
              this.changeStrikeImage(this.posY, this.posX, true);
            }

            this.itemFade();
          }
          break;

        case "remove":
          this.checkFalling();
          break;

        case "refill":
          this.placeNewItems();
          break;
      }

      if (this.selectedItemRef.classList.contains("item-selected"))
        this.selectedItemRef.classList.remove("item-selected");
    }
  }

  changeStrikeImage(x: number, y: number, isVertical: boolean) {
    const xStrike = isVertical
      ? x * this.itemSize + "px"
      : y * this.itemSize + "px";
    const yStrike = isVertical
      ? y * this.itemSize + "px"
      : x * this.itemSize + "px";

    this.renderer.setStyle(
      this.strikeImage ? this.strikeImage.nativeElement : undefined,
      "top",
      xStrike
    );
    this.renderer.setStyle(
      this.strikeImage ? this.strikeImage.nativeElement : undefined,
      "left",
      yStrike
    );
    this.renderer.setStyle(
      this.strikeImage ? this.strikeImage.nativeElement : undefined,
      "display",
      "block"
    );

    setTimeout(() => {
      this.renderer.setStyle(
        this.strikeImage ? this.strikeImage.nativeElement : undefined,
        "display",
        "none"
      );
    }, 1500);
  }

  removeItems(row: number, col: number) {
    const itemValue = this.items[row][col];

    if (this.itemStarted == -1) {
      this.itemStarted = itemValue - 1;
    }

    let tmp = row;
    const removingItem = this.getItem(row, col);
    this.renderer.addClass(removingItem, "remove");

    let currentScore: number = 0;

    //Band to prevent L streak remove if it's valid streak
    let justOne: boolean = false;

    if (this.isVerticalStreak(row, col) && !justOne) {
      justOne = true;
      while (tmp > 0 && this.items[tmp - 1][col] === itemValue) {
        const item = this.getItem(tmp - 1, col);
        this.renderer.addClass(item, "remove");
        this.items[tmp - 1][col] = -1;
        tmp--;
        currentScore += 1;
      }

      tmp = row;

      while (tmp < this.numRows - 1 && this.items[tmp + 1][col] === itemValue) {
        const item = this.getItem(tmp + 1, col);
        this.renderer.addClass(item, "remove");
        this.items[tmp + 1][col] = -1;
        tmp++;
        currentScore += 1;
      }

      this.addScore(currentScore);
    }
    if (this.isHorizontalStreak(row, col) && !justOne) {
      justOne = true;
      tmp = col;

      while (tmp > 0 && this.items[row][tmp - 1] === itemValue) {
        const item = this.getItem(row, tmp - 1);
        this.renderer.addClass(item, "remove");
        this.items[row][tmp - 1] = -1;
        tmp--;
        currentScore += 1;
      }

      tmp = col;

      while (tmp < this.numCols - 1 && this.items[row][tmp + 1] === itemValue) {
        const item = this.getItem(row, tmp + 1);
        this.renderer.addClass(item, "remove");
        this.items[row][tmp + 1] = -1;
        tmp++;
        currentScore += 1;
      }

      this.addScore(currentScore);
    }

    currentScore += 1;

    this.items[row][col] = -1;
  }

  //Score added when strike
  addScore(score: number) {
    if (score === 2) {
      this.points += 5;
      this.makePoints.emit(5);
    } else if (score === 3) {
      this.points += 5;
      this.makePoints.emit(5);
    } else if (score === 4) {
      this.points += 5;
      this.makePoints.emit(5);
    }
  }

  itemFade() {
    const itemsToRemove = document.querySelectorAll(
      ".remove"
    ) as NodeListOf<HTMLElement>;

    let type =
      itemsToRemove.length > 0
        ? itemsToRemove[0].getAttribute("data-type")
        : -1;
    // this.sound.play();
    if (type == 2) {
      this.counter++;
    }

    itemsToRemove.forEach((item) => {
      this.movingItems++;
      const itemRemoveAnimation = this._builder.build([
        style({ opacity: 1 }),
        animate(500, style({ opacity: 0 })),
      ]);

      const player = itemRemoveAnimation.create(item);

      player.onDone(() => {
        this.renderer.setStyle(item, "opacity", 0);
        item.remove();
        this.checkMoving();
      });
      player.play();
    });
  }

  checkFalling() {
    let fellDown = 0;

    for (let j = 0; j < this.numCols; j++) {
      for (let i = this.numRows - 1; i > 0; i--) {
        if (this.items[i][j] === -1 && this.items[i - 1][j] >= 0) {
          const item = this.getItem(i - 1, j);
          this.renderer.addClass(item, "fall");
          this.renderer.setAttribute(item, "id", this.getId(i, j));
          this.items[i][j] = this.items[i - 1][j];
          this.items[i - 1][j] = -1;
          fellDown++;
        }
      }
    }

    const itemsToFall = document.querySelectorAll(
      ".fall"
    ) as NodeListOf<HTMLElement>;

    itemsToFall.forEach((item) => {
      this.movingItems++;
      const currentTop = +item.style.top.replace("px", "") + this.gap;
      const needTop = +currentTop + this.itemSize;
      const itemFallAnimation = this._builder.build([
        style({ top: +currentTop + "px" }),
        animate(150, style({ top: needTop + "px" })),
      ]);
      const player = itemFallAnimation.create(item);
      player.onDone(() => {
        this.renderer.setStyle(item, "top", needTop + "px");
        this.renderer.removeClass(item, "fall");
        this.checkMoving();
      });
      player.play();
    });

    if (fellDown === 0) {
      this.itemState = "refill";
      this.movingItems = 1;
      this.checkMoving();
    }
  }

  placeNewItems() {
    let itemsPlaced = 0;
    for (let i = 0; i < this.numCols; i++) {
      if (this.items[0][i] === -1) {
        this.items[0][i] = Math.floor(Math.random() * this.itemNumber) + 1;
        const item = this.renderer.createElement("div");
        this.renderer.appendChild(
          this.gameField ? this.gameField.nativeElement : undefined,
          item
        );
        this.renderer.addClass(item, this.itemClass);
        this.renderer.setAttribute(item, "data-type", String(this.items[0][i]));
        this.renderer.setAttribute(item, "id", this.getId(0, i));
        this.renderer.setStyle(item, "top", "0px");
        this.renderer.setStyle(
          item,
          "left",
          i * (this.itemSize + this.gap) + "px"
        );
        this.renderer.addClass(item, this.tiles[this.items[0][i] - 1]);

        this.renderer.setStyle(item, "background-size", "100%");
        this.renderer.setStyle(item, "background-repeat", "no-repeat");
        this.renderer.setStyle(item, "background-position", "center");
        this.renderer.setStyle(item, "width", this.itemSize + "px");
        this.renderer.setStyle(item, "height", this.itemSize + "px");
        this.renderer.setStyle(item, "aspect-ratio", "1");

        itemsPlaced++;
        //this.counter++;
      }
    }

    if (itemsPlaced) {
      this.itemState = "remove";
      this.checkFalling();
    } else {
      let combo = 0;

      for (let i = 0; i < this.numRows; i++) {
        for (let j = 0; j < this.numCols; j++) {
          if (
            j <= this.numCols - 3 &&
            this.items[i][j] === this.items[i][j + 1] &&
            this.items[i][j] === this.items[i][j + 2]
          ) {
            combo++;
            this.removeItems(i, j);
          }
          if (
            i <= this.numRows - 3 &&
            this.items[i][j] === this.items[i + 1][j] &&
            this.items[i][j] === this.items[i + 2][j]
          ) {
            combo++;
            this.removeItems(i, j);
          }
        }
      }

      if (combo > 0) {
        this.itemState = "remove";
        this.itemFade();
      } else {
        this.correctMoves++;
        this.onCorrectMoves.emit(this.correctMoves);
        this.itemState = "pick";
        this.selectedRow = -1;
      }
    }

    if (this.movements >= this.maxMoves) {
      this.blocked = true;
    }
  }

  swipe(event: any, type = this.SWIPE_ACTION.RIGHT) {
    if (event.target) {
      if (this.itemState === "pick") {
        this.selectedRow = +event.target.getAttribute("id").split("_")[1];
        this.selectedCol = +event.target.getAttribute("id").split("_")[2];

        //this.counter = 0;
        this.itemStarted = -1;

        switch (type) {
          case this.SWIPE_ACTION.UP:
            if (this.selectedRow > 0) {
              if (this.selectedItemRef.classList.contains("item-selected"))
                this.selectedItemRef.classList.remove("item-selected");

              this.itemState = "switch";
              this.posX = this.selectedCol;
              this.posY = this.selectedRow - 1;
              this.productSwitch();
            }

            break;
          case this.SWIPE_ACTION.DOWN:
            if (this.selectedRow < this.numRows - 1) {
              if (this.selectedItemRef.classList.contains("item-selected"))
                this.selectedItemRef.classList.remove("item-selected");

              this.itemState = "switch";
              this.posX = this.selectedCol;
              this.posY = this.selectedRow + 1;
              this.productSwitch();
            }

            break;
          case this.SWIPE_ACTION.LEFT:
            if (this.selectedCol > 0) {
              if (this.selectedItemRef.classList.contains("item-selected"))
                this.selectedItemRef.classList.remove("item-selected");

              this.itemState = "switch";
              this.posX = this.selectedCol - 1;
              this.posY = this.selectedRow;
              this.productSwitch();
            }

            break;
          case this.SWIPE_ACTION.RIGHT:
            if (this.selectedCol < this.numRows - 1) {
              if (this.selectedItemRef.classList.contains("item-selected"))
                this.selectedItemRef.classList.remove("item-selected");

              this.itemState = "switch";
              this.posX = this.selectedCol + 1;
              this.posY = this.selectedRow;
              this.productSwitch();
            }

            break;
        }

        this.handleMovements();
      }
    }
  }
}
